import { BASE_PATH as i, BaseAPI as V, operationServerMap as d } from "../base.js";
import { DUMMY_BASE_URL as p, assertParamExists as O, createRequestFunction as P, serializeDataIfNeeded as k, setSearchParams as v, toPathString as I } from "../common.js";
import S from "axios";
var G = function(a) {
  return {
    merchantPurchaseBatchCreateSku: async (s, n = {}) => {
      O("merchantPurchaseBatchCreateSku", "purchaseSkuBatchCreateRequest", s);
      const t = new URL("/merchant/purchase/sku/batch_create", p);
      let e;
      a && (e = a.baseOptions);
      const r = {
        method: "POST",
        ...e,
        ...n
      }, c = {}, o = {};
      c["Content-Type"] = "application/json", v(t, o);
      let h = e && e.headers ? e.headers : {};
      return r.headers = {
        ...c,
        ...h,
        ...n.headers
      }, r.data = k(s, r, a), {
        url: I(t),
        options: r
      };
    },
    merchantPurchaseBatchCreateSkuByTemplate: async (s, n = {}) => {
      O("merchantPurchaseBatchCreateSkuByTemplate", "purchaseTemplateBatchCreateRequest", s);
      const t = new URL("/merchant/purchase/sku/template_batch_create", p);
      let e;
      a && (e = a.baseOptions);
      const r = {
        method: "POST",
        ...e,
        ...n
      }, c = {}, o = {};
      c["Content-Type"] = "application/json", v(t, o);
      let h = e && e.headers ? e.headers : {};
      return r.headers = {
        ...c,
        ...h,
        ...n.headers
      }, r.data = k(s, r, a), {
        url: I(t),
        options: r
      };
    },
    merchantPurchaseCancelStockIn: async (s, n = {}) => {
      O("merchantPurchaseCancelStockIn", "purchaseStockInCancelRequest", s);
      const t = new URL("/merchant/purchase/stock_in/cancel", p);
      let e;
      a && (e = a.baseOptions);
      const r = {
        method: "POST",
        ...e,
        ...n
      }, c = {}, o = {};
      c["Content-Type"] = "application/json", v(t, o);
      let h = e && e.headers ? e.headers : {};
      return r.headers = {
        ...c,
        ...h,
        ...n.headers
      }, r.data = k(s, r, a), {
        url: I(t),
        options: r
      };
    },
    merchantPurchaseGetLwmsBindingsInfo: async (s = {}) => {
      const n = new URL("/merchant/purchase/lwms/bindings", p);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...s
      }, r = {};
      v(n, {});
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...r,
        ...c,
        ...s.headers
      }, {
        url: I(n),
        options: e
      };
    },
    merchantPurchaseGetLwmsConsumptionInfo: async (s, n = {}) => {
      O("merchantPurchaseGetLwmsConsumptionInfo", "itemId", s);
      const t = new URL("/merchant/purchase/lwms/consumption", p);
      let e;
      a && (e = a.baseOptions);
      const r = {
        method: "GET",
        ...e,
        ...n
      }, c = {}, o = {};
      s !== void 0 && (o.itemId = s), v(t, o);
      let h = e && e.headers ? e.headers : {};
      return r.headers = {
        ...c,
        ...h,
        ...n.headers
      }, {
        url: I(t),
        options: r
      };
    },
    merchantPurchaseGetLwmsInsufficientStockInfo: async (s = {}) => {
      const n = new URL("/merchant/purchase/lwms/insufficient", p);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...s
      }, r = {};
      v(n, {});
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...r,
        ...c,
        ...s.headers
      }, {
        url: I(n),
        options: e
      };
    },
    merchantPurchaseGetLwmsStockAlertInfo: async (s = {}) => {
      const n = new URL("/merchant/purchase/lwms/alert", p);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...s
      }, r = {};
      v(n, {});
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...r,
        ...c,
        ...s.headers
      }, {
        url: I(n),
        options: e
      };
    },
    merchantPurchaseGetStockInRecords: async (s, n = {}) => {
      O("merchantPurchaseGetStockInRecords", "supplierOmsOrderId", s);
      const t = new URL("/merchant/purchase/stock_in/records", p);
      let e;
      a && (e = a.baseOptions);
      const r = {
        method: "GET",
        ...e,
        ...n
      }, c = {}, o = {};
      s !== void 0 && (o.supplierOmsOrderId = s), v(t, o);
      let h = e && e.headers ? e.headers : {};
      return r.headers = {
        ...c,
        ...h,
        ...n.headers
      }, {
        url: I(t),
        options: r
      };
    },
    merchantPurchaseGetWmsBindingsInfo: async (s = {}) => {
      const n = new URL("/merchant/purchase/wms/bindings", p);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...s
      }, r = {};
      v(n, {});
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...r,
        ...c,
        ...s.headers
      }, {
        url: I(n),
        options: e
      };
    },
    merchantPurchaseGetWmsConsumptionInfo: async (s, n = {}) => {
      O("merchantPurchaseGetWmsConsumptionInfo", "skuId", s);
      const t = new URL("/merchant/purchase/wms/consumption", p);
      let e;
      a && (e = a.baseOptions);
      const r = {
        method: "GET",
        ...e,
        ...n
      }, c = {}, o = {};
      s !== void 0 && (o.skuId = s), v(t, o);
      let h = e && e.headers ? e.headers : {};
      return r.headers = {
        ...c,
        ...h,
        ...n.headers
      }, {
        url: I(t),
        options: r
      };
    },
    merchantPurchaseGetWmsInsufficientStockInfo: async (s = {}) => {
      const n = new URL("/merchant/purchase/wms/insufficient", p);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...s
      }, r = {};
      v(n, {});
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...r,
        ...c,
        ...s.headers
      }, {
        url: I(n),
        options: e
      };
    },
    merchantPurchaseGetWmsStockAlertInfo: async (s = {}) => {
      const n = new URL("/merchant/purchase/wms/alert", p);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...s
      }, r = {};
      v(n, {});
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...r,
        ...c,
        ...s.headers
      }, {
        url: I(n),
        options: e
      };
    },
    merchantPurchaseMergeItem: async (s, n = {}) => {
      O("merchantPurchaseMergeItem", "purchaseItemMergeRequest", s);
      const t = new URL("/merchant/purchase/item/merge_item", p);
      let e;
      a && (e = a.baseOptions);
      const r = {
        method: "POST",
        ...e,
        ...n
      }, c = {}, o = {};
      c["Content-Type"] = "application/json", v(t, o);
      let h = e && e.headers ? e.headers : {};
      return r.headers = {
        ...c,
        ...h,
        ...n.headers
      }, r.data = k(s, r, a), {
        url: I(t),
        options: r
      };
    },
    merchantPurchaseOneClickStockIn: async (s, n = {}) => {
      O("merchantPurchaseOneClickStockIn", "purchaseStockInRequest", s);
      const t = new URL("/merchant/purchase/stock_in/one_click", p);
      let e;
      a && (e = a.baseOptions);
      const r = {
        method: "POST",
        ...e,
        ...n
      }, c = {}, o = {};
      c["Content-Type"] = "application/json", v(t, o);
      let h = e && e.headers ? e.headers : {};
      return r.headers = {
        ...c,
        ...h,
        ...n.headers
      }, r.data = k(s, r, a), {
        url: I(t),
        options: r
      };
    }
  };
}, m = function(a) {
  const s = G(a);
  return {
    async merchantPurchaseBatchCreateSku(n, t) {
      var e, r;
      const c = await s.merchantPurchaseBatchCreateSku(n, t), o = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, h = (r = d["MerchantPurchaseApi.merchantPurchaseBatchCreateSku"]) === null || r === void 0 || (r = r[o]) === null || r === void 0 ? void 0 : r.url;
      return (l, u) => P(c, S, i, a)(l, h || u);
    },
    async merchantPurchaseBatchCreateSkuByTemplate(n, t) {
      var e, r;
      const c = await s.merchantPurchaseBatchCreateSkuByTemplate(n, t), o = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, h = (r = d["MerchantPurchaseApi.merchantPurchaseBatchCreateSkuByTemplate"]) === null || r === void 0 || (r = r[o]) === null || r === void 0 ? void 0 : r.url;
      return (l, u) => P(c, S, i, a)(l, h || u);
    },
    async merchantPurchaseCancelStockIn(n, t) {
      var e, r;
      const c = await s.merchantPurchaseCancelStockIn(n, t), o = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, h = (r = d["MerchantPurchaseApi.merchantPurchaseCancelStockIn"]) === null || r === void 0 || (r = r[o]) === null || r === void 0 ? void 0 : r.url;
      return (l, u) => P(c, S, i, a)(l, h || u);
    },
    async merchantPurchaseGetLwmsBindingsInfo(n) {
      var t, e;
      const r = await s.merchantPurchaseGetLwmsBindingsInfo(n), c = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = d["MerchantPurchaseApi.merchantPurchaseGetLwmsBindingsInfo"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (h, l) => P(r, S, i, a)(h, o || l);
    },
    async merchantPurchaseGetLwmsConsumptionInfo(n, t) {
      var e, r;
      const c = await s.merchantPurchaseGetLwmsConsumptionInfo(n, t), o = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, h = (r = d["MerchantPurchaseApi.merchantPurchaseGetLwmsConsumptionInfo"]) === null || r === void 0 || (r = r[o]) === null || r === void 0 ? void 0 : r.url;
      return (l, u) => P(c, S, i, a)(l, h || u);
    },
    async merchantPurchaseGetLwmsInsufficientStockInfo(n) {
      var t, e;
      const r = await s.merchantPurchaseGetLwmsInsufficientStockInfo(n), c = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = d["MerchantPurchaseApi.merchantPurchaseGetLwmsInsufficientStockInfo"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (h, l) => P(r, S, i, a)(h, o || l);
    },
    async merchantPurchaseGetLwmsStockAlertInfo(n) {
      var t, e;
      const r = await s.merchantPurchaseGetLwmsStockAlertInfo(n), c = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = d["MerchantPurchaseApi.merchantPurchaseGetLwmsStockAlertInfo"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (h, l) => P(r, S, i, a)(h, o || l);
    },
    async merchantPurchaseGetStockInRecords(n, t) {
      var e, r;
      const c = await s.merchantPurchaseGetStockInRecords(n, t), o = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, h = (r = d["MerchantPurchaseApi.merchantPurchaseGetStockInRecords"]) === null || r === void 0 || (r = r[o]) === null || r === void 0 ? void 0 : r.url;
      return (l, u) => P(c, S, i, a)(l, h || u);
    },
    async merchantPurchaseGetWmsBindingsInfo(n) {
      var t, e;
      const r = await s.merchantPurchaseGetWmsBindingsInfo(n), c = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = d["MerchantPurchaseApi.merchantPurchaseGetWmsBindingsInfo"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (h, l) => P(r, S, i, a)(h, o || l);
    },
    async merchantPurchaseGetWmsConsumptionInfo(n, t) {
      var e, r;
      const c = await s.merchantPurchaseGetWmsConsumptionInfo(n, t), o = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, h = (r = d["MerchantPurchaseApi.merchantPurchaseGetWmsConsumptionInfo"]) === null || r === void 0 || (r = r[o]) === null || r === void 0 ? void 0 : r.url;
      return (l, u) => P(c, S, i, a)(l, h || u);
    },
    async merchantPurchaseGetWmsInsufficientStockInfo(n) {
      var t, e;
      const r = await s.merchantPurchaseGetWmsInsufficientStockInfo(n), c = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = d["MerchantPurchaseApi.merchantPurchaseGetWmsInsufficientStockInfo"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (h, l) => P(r, S, i, a)(h, o || l);
    },
    async merchantPurchaseGetWmsStockAlertInfo(n) {
      var t, e;
      const r = await s.merchantPurchaseGetWmsStockAlertInfo(n), c = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = d["MerchantPurchaseApi.merchantPurchaseGetWmsStockAlertInfo"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (h, l) => P(r, S, i, a)(h, o || l);
    },
    async merchantPurchaseMergeItem(n, t) {
      var e, r;
      const c = await s.merchantPurchaseMergeItem(n, t), o = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, h = (r = d["MerchantPurchaseApi.merchantPurchaseMergeItem"]) === null || r === void 0 || (r = r[o]) === null || r === void 0 ? void 0 : r.url;
      return (l, u) => P(c, S, i, a)(l, h || u);
    },
    async merchantPurchaseOneClickStockIn(n, t) {
      var e, r;
      const c = await s.merchantPurchaseOneClickStockIn(n, t), o = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, h = (r = d["MerchantPurchaseApi.merchantPurchaseOneClickStockIn"]) === null || r === void 0 || (r = r[o]) === null || r === void 0 ? void 0 : r.url;
      return (l, u) => P(c, S, i, a)(l, h || u);
    }
  };
}, C = function(a, s, n) {
  const t = m(a);
  return {
    merchantPurchaseBatchCreateSku(e, r) {
      return t.merchantPurchaseBatchCreateSku(e.purchaseSkuBatchCreateRequest, r).then((c) => c(n, s));
    },
    merchantPurchaseBatchCreateSkuByTemplate(e, r) {
      return t.merchantPurchaseBatchCreateSkuByTemplate(e.purchaseTemplateBatchCreateRequest, r).then((c) => c(n, s));
    },
    merchantPurchaseCancelStockIn(e, r) {
      return t.merchantPurchaseCancelStockIn(e.purchaseStockInCancelRequest, r).then((c) => c(n, s));
    },
    merchantPurchaseGetLwmsBindingsInfo(e) {
      return t.merchantPurchaseGetLwmsBindingsInfo(e).then((r) => r(n, s));
    },
    merchantPurchaseGetLwmsConsumptionInfo(e, r) {
      return t.merchantPurchaseGetLwmsConsumptionInfo(e.itemId, r).then((c) => c(n, s));
    },
    merchantPurchaseGetLwmsInsufficientStockInfo(e) {
      return t.merchantPurchaseGetLwmsInsufficientStockInfo(e).then((r) => r(n, s));
    },
    merchantPurchaseGetLwmsStockAlertInfo(e) {
      return t.merchantPurchaseGetLwmsStockAlertInfo(e).then((r) => r(n, s));
    },
    merchantPurchaseGetStockInRecords(e, r) {
      return t.merchantPurchaseGetStockInRecords(e.supplierOmsOrderId, r).then((c) => c(n, s));
    },
    merchantPurchaseGetWmsBindingsInfo(e) {
      return t.merchantPurchaseGetWmsBindingsInfo(e).then((r) => r(n, s));
    },
    merchantPurchaseGetWmsConsumptionInfo(e, r) {
      return t.merchantPurchaseGetWmsConsumptionInfo(e.skuId, r).then((c) => c(n, s));
    },
    merchantPurchaseGetWmsInsufficientStockInfo(e) {
      return t.merchantPurchaseGetWmsInsufficientStockInfo(e).then((r) => r(n, s));
    },
    merchantPurchaseGetWmsStockAlertInfo(e) {
      return t.merchantPurchaseGetWmsStockAlertInfo(e).then((r) => r(n, s));
    },
    merchantPurchaseMergeItem(e, r) {
      return t.merchantPurchaseMergeItem(e.purchaseItemMergeRequest, r).then((c) => c(n, s));
    },
    merchantPurchaseOneClickStockIn(e, r) {
      return t.merchantPurchaseOneClickStockIn(e.purchaseStockInRequest, r).then((c) => c(n, s));
    }
  };
}, f = class extends V {
  merchantPurchaseBatchCreateSku(a, s) {
    return m(this.configuration).merchantPurchaseBatchCreateSku(a.purchaseSkuBatchCreateRequest, s).then((n) => n(this.axios, this.basePath));
  }
  merchantPurchaseBatchCreateSkuByTemplate(a, s) {
    return m(this.configuration).merchantPurchaseBatchCreateSkuByTemplate(a.purchaseTemplateBatchCreateRequest, s).then((n) => n(this.axios, this.basePath));
  }
  merchantPurchaseCancelStockIn(a, s) {
    return m(this.configuration).merchantPurchaseCancelStockIn(a.purchaseStockInCancelRequest, s).then((n) => n(this.axios, this.basePath));
  }
  merchantPurchaseGetLwmsBindingsInfo(a) {
    return m(this.configuration).merchantPurchaseGetLwmsBindingsInfo(a).then((s) => s(this.axios, this.basePath));
  }
  merchantPurchaseGetLwmsConsumptionInfo(a, s) {
    return m(this.configuration).merchantPurchaseGetLwmsConsumptionInfo(a.itemId, s).then((n) => n(this.axios, this.basePath));
  }
  merchantPurchaseGetLwmsInsufficientStockInfo(a) {
    return m(this.configuration).merchantPurchaseGetLwmsInsufficientStockInfo(a).then((s) => s(this.axios, this.basePath));
  }
  merchantPurchaseGetLwmsStockAlertInfo(a) {
    return m(this.configuration).merchantPurchaseGetLwmsStockAlertInfo(a).then((s) => s(this.axios, this.basePath));
  }
  merchantPurchaseGetStockInRecords(a, s) {
    return m(this.configuration).merchantPurchaseGetStockInRecords(a.supplierOmsOrderId, s).then((n) => n(this.axios, this.basePath));
  }
  merchantPurchaseGetWmsBindingsInfo(a) {
    return m(this.configuration).merchantPurchaseGetWmsBindingsInfo(a).then((s) => s(this.axios, this.basePath));
  }
  merchantPurchaseGetWmsConsumptionInfo(a, s) {
    return m(this.configuration).merchantPurchaseGetWmsConsumptionInfo(a.skuId, s).then((n) => n(this.axios, this.basePath));
  }
  merchantPurchaseGetWmsInsufficientStockInfo(a) {
    return m(this.configuration).merchantPurchaseGetWmsInsufficientStockInfo(a).then((s) => s(this.axios, this.basePath));
  }
  merchantPurchaseGetWmsStockAlertInfo(a) {
    return m(this.configuration).merchantPurchaseGetWmsStockAlertInfo(a).then((s) => s(this.axios, this.basePath));
  }
  merchantPurchaseMergeItem(a, s) {
    return m(this.configuration).merchantPurchaseMergeItem(a.purchaseItemMergeRequest, s).then((n) => n(this.axios, this.basePath));
  }
  merchantPurchaseOneClickStockIn(a, s) {
    return m(this.configuration).merchantPurchaseOneClickStockIn(a.purchaseStockInRequest, s).then((n) => n(this.axios, this.basePath));
  }
};
export {
  f as MerchantPurchaseApi,
  G as MerchantPurchaseApiAxiosParamCreator,
  C as MerchantPurchaseApiFactory,
  m as MerchantPurchaseApiFp
};

//# sourceMappingURL=merchant-purchase-api.js.map